import { render, staticRenderFns } from "./avatarListRow.vue?vue&type=template&id=b49e66fa&scoped=true"
import script from "./avatarListRow.vue?vue&type=script&lang=js"
export * from "./avatarListRow.vue?vue&type=script&lang=js"
import style0 from "./avatarListRow.vue?vue&type=style&index=0&id=b49e66fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49e66fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b49e66fa')) {
      api.createRecord('b49e66fa', component.options)
    } else {
      api.reload('b49e66fa', component.options)
    }
    module.hot.accept("./avatarListRow.vue?vue&type=template&id=b49e66fa&scoped=true", function () {
      api.rerender('b49e66fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cooperationMall/avatarListRow.vue"
export default component.exports